import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { byIdMap } from 'relevant-shared/objects/objectStore';
import { Link } from '../Link/Link';
import FieldDataObject from './fieldDataObject';
import { ActionButton } from '../ActionButton/ActionButton';
import TextEditor from './textEditor';
import PrebidBuildFormModal from '../PrebidBuild/PrebidBuildFormModal';
import PrebidBuildManager from '../PrebidBuild/PrebidBuildManager';
import TagPreviewEditor from '../TagPreviewEditor';
import Form from '../../containers/Form';

class TagDataEditor extends React.Component {
	constructor(props) {
		super(props);
		const { type, id } = props.dataId;
		const byPubId = byIdMap('Publisher');
		let publisher;
		let site;
		if (type === 'sspSiteId') {
			const all = _.values(byPubId).map((p) => p.websites.map((s) => [s, p])).flat();
			[site, publisher] = all.find(([s]) => s.id === id) || [];
		} else if (type === 'sspPublisherId') {
			publisher = byPubId[id];
		}
		this.state = { publisher, site };
	}

	renderAudienceTag() {
		const { info } = this.props;
		const tagStyle = { backgroundColor: 'lightgray', borderRadius: '10px', padding: '10px' };
		return (
			<Card>
				<CardContent>
					<Typography variant="h4">
						Info
					</Typography>
					Place on site:&nbsp;&nbsp;
					<span style={tagStyle}>
						{'<script type="application/javascript" async src="'}
						<a href={info.cdnUrl} target="_blank" rel="noreferrer">{info.cdnUrl}</a>
						{'"></script>'}
					</span>
				</CardContent>
			</Card>
		);
	}

	renderProgrammaticTag() {
		const { info } = this.props;
		const tag = `<!-- This script can be loaded at any time, including after initial prebid auction / ad requests -->
<script async src="${info.cdnUrl}"></script>`;
		return (
			<Card>
				<CardContent style={{ paddingBottom: 8 }}>
					<Typography variant="h2">
						Analytics tag, for analytics-only use
					</Typography>
					<TextEditor
						width="100%"
						height="40px"
						name="programmaticTag"
						readOnly
						showGutter={false}
						value={tag}
					/>
				</CardContent>
			</Card>
		);
	}

	render() {
		const {
			model, field, form, onCancel, submit, info, type, match, location, dataId,
		} = this.props;
		const { publisher, site } = this.state;
		const hasSubPath = (p) => window.location.pathname.startsWith(`${match.path}${p}`);
		const pushHistory = (p) => {
			window.history.pushState({}, '', p);
			form.update();
		};
		return (
			<TagPreviewEditor
				publisher={publisher}
				getOnScreenTagObject={() => model}
				dataId={dataId}
				pubSelect={dataId.type === 'programmaticMasterTag'}
				form={form}
				extraPushPx={28 /* Some issue here with <Grid container> being above us, causing negative margins of Grid items below */}
			>
				{publisher && (
					<Grid item xs={12} style={{ padding: '0 0 8px 0' }}>
						<Link href={`/accounts/${publisher.id}`}>
							Account: {publisher.name}
						</Link>
						{site && (
							<>
								&nbsp;>&nbsp;
								<Link href={`/accounts/${publisher.id}/sites/${site.id}`}>
									Site: {site.domain}
								</Link>
							</>
						)}
					</Grid>
				)}
				{info.isLeaf
					&& (
						<Grid item xs={12} style={{ padding: '0 0 24px 0' }}>
							{ type === 'programmatic' ? this.renderProgrammaticTag() : this.renderAudienceTag() }
						</Grid>
					)}
				<FieldDataObject model={model} field={field} />
				<Grid item>
					<ActionButton
						label="Save"
						color="primary"
						onClick={submit}
					/>
				</Grid>
				<Grid item>
					<ActionButton
						label="Cancel"
						onClick={() => onCancel()}
						variant="text"
						color="primary"
					/>
				</Grid>
				{hasSubPath('/add-prebid-build') && (
					<PrebidBuildFormModal
						match={match}
						location={location}
						pushHistory={pushHistory}
					/>
				)}
				{hasSubPath('/manage-prebid-builds') && (
					<PrebidBuildManager
						match={match}
						location={location}
						pushHistory={pushHistory}
					/>
				)}
			</TagPreviewEditor>
		);
	}
}

TagDataEditor.propTypes = {
	model: PropTypes.object.isRequired,
	field: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	submit: PropTypes.func.isRequired,
	info: PropTypes.object.isRequired,
	type: PropTypes.oneOf(['programmatic', 'audience']).isRequired,
	dataId: PropTypes.object.isRequired,
};

TagDataEditor.defaultProps = {
};

export default TagDataEditor;
